import otherBooks_01_prev from '../images/other-books/other-books-01-preview.webp';
import otherBooks_01_orig from '../images/other-books/other-books-01-original.webp';
import otherBooks_02_prev from '../images/other-books/other-books-02-preview.webp';
import otherBooks_02_orig from '../images/other-books/other-books-02-original.webp';
import otherBooks_03_prev from '../images/other-books/other-books-03-preview.webp';
import otherBooks_03_orig from '../images/other-books/other-books-03-original.webp';
import otherBooks_04_prev from '../images/other-books/other-books-04-preview.webp';
import otherBooks_04_orig from '../images/other-books/other-books-04-original.webp';
import otherBooks_05_prev from '../images/other-books/other-books-05-preview.webp';
import otherBooks_05_orig from '../images/other-books/other-books-05-original.webp';
import otherBooks_06_prev from '../images/other-books/other-books-06-preview.webp';
import otherBooks_06_orig from '../images/other-books/other-books-06-original.webp';
import otherBooks_07_prev from '../images/other-books/other-books-07-preview.webp';
import otherBooks_07_orig from '../images/other-books/other-books-07-original.webp';
import otherBooks_08_prev from '../images/other-books/other-books-08-preview.webp';
import otherBooks_08_orig from '../images/other-books/other-books-08-original.webp';
import otherBooks_09_prev from '../images/other-books/other-books-09-preview.webp';
import otherBooks_09_orig from '../images/other-books/other-books-09-original.webp';
import otherBooks_10_prev from '../images/other-books/other-books-10-preview.webp';
import otherBooks_10_orig from '../images/other-books/other-books-10-original.webp';
import otherBooks_11_prev from '../images/other-books/other-books-11-preview.webp';
import otherBooks_11_orig from '../images/other-books/other-books-11-original.webp';
import otherBooks_12_prev from '../images/other-books/other-books-12-preview.webp';
import otherBooks_12_orig from '../images/other-books/other-books-12-original.webp';
import otherBooks_13_prev from '../images/other-books/other-books-13-preview.webp';
import otherBooks_13_orig from '../images/other-books/other-books-13-original.webp';
import otherBooks_14_prev from '../images/other-books/other-books-14-preview.webp';
import otherBooks_14_orig from '../images/other-books/other-books-14-original.webp';
import otherBooks_15_prev from '../images/other-books/other-books-15-preview.webp';
import otherBooks_15_orig from '../images/other-books/other-books-15-original.webp';
import otherBooks_16_prev from '../images/other-books/other-books-16-preview.webp';
import otherBooks_16_orig from '../images/other-books/other-books-16-original.webp';
import otherBooks_17_prev from '../images/other-books/other-books-17-preview@1x.webp';
import otherBooks_17_orig from '../images/other-books/other-books-17-original@1x.webp';
import otherBooks_18_prev from '../images/other-books/other-books-18-preview@1x.webp';
import otherBooks_18_orig from '../images/other-books/other-books-18-original@1x.webp';
import otherBooks_19_prev from '../images/other-books/other-books-19-preview@1x.webp';
import otherBooks_19_orig from '../images/other-books/other-books-19-original@1x.webp';
import otherBooks_20_prev from '../images/other-books/other-books-20-preview@1x.webp';
import otherBooks_20_orig from '../images/other-books/other-books-20-original@1x.webp';
import otherBooks_21_prev from '../images/other-books/other-books-21-preview@1x.webp';
import otherBooks_21_orig from '../images/other-books/other-books-21-original@1x.webp';
import otherBooks_22_prev from '../images/other-books/other-books-22-preview@1x.webp';
import otherBooks_22_orig from '../images/other-books/other-books-22-original@1x.webp';
import otherBooks_23_prev from '../images/other-books/other-books-23-preview@1x.webp';
import otherBooks_23_orig from '../images/other-books/other-books-23-original@1x.webp';
import otherBooks_24_prev from '../images/other-books/other-books-24-preview@1x.webp';
import otherBooks_24_orig from '../images/other-books/other-books-24-original@1x.webp';

export const otherBooksGalleryItems = [
  {
    preview: otherBooks_01_prev,
    original: otherBooks_01_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_02_prev,
    original: otherBooks_02_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_03_prev,
    original: otherBooks_03_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_04_prev,
    original: otherBooks_04_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_05_prev,
    original: otherBooks_05_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_06_prev,
    original: otherBooks_06_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_07_prev,
    original: otherBooks_07_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_08_prev,
    original: otherBooks_08_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_09_prev,
    original: otherBooks_09_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_10_prev,
    original: otherBooks_10_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_11_prev,
    original: otherBooks_11_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_12_prev,
    original: otherBooks_12_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_13_prev,
    original: otherBooks_13_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_14_prev,
    original: otherBooks_14_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_15_prev,
    original: otherBooks_15_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_16_prev,
    original: otherBooks_16_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_17_prev,
    original: otherBooks_17_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_18_prev,
    original: otherBooks_18_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_19_prev,
    original: otherBooks_19_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_20_prev,
    original: otherBooks_20_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_21_prev,
    original: otherBooks_21_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_22_prev,
    original: otherBooks_22_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_23_prev,
    original: otherBooks_23_orig,
    description: 'This is my book in another language',
  },
  {
    preview: otherBooks_24_prev,
    original: otherBooks_24_orig,
    description: 'This is my book in another language',
  },
];
